import { render } from "./OrganisationDetail.vue?vue&type=template&id=020f83d5"
import script from "./OrganisationDetail.vue?vue&type=script&lang=js"
export * from "./OrganisationDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__